// extracted by mini-css-extract-plugin
export default {"createButton":"TabProfile_createButton__gIPq+"};